import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Style } from '@local/client-contracts';
import { SuggestionsItem } from '../../models/results-types';

@Component({
  selector: 'suggestions-item',
  templateUrl: './suggestions-item.component.html',
  styleUrls: ['./suggestions-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestionsItemComponent {
  @Input() model: SuggestionsItem;
  defaultIcon: Style.EntityIcon<'font-icon'> = { type: 'font-icon', value: 'icon-sort-down' };
}
